import { Dispatch } from "@reduxjs/toolkit";
import { setPostsLoading, setPostError, setPostsResponse, setBirthdaysYearRequested} from "./postsSlice";
import { AxiosResponse } from "axios";
import { getPostsRequest, getUnApprovedPostsRequest } from "../../../api/employeePortal";
import { GetPostsResponse, PostRequest } from "../../../interfaces/post.interface";
import { getEmployeesBithdays } from "../../../api/signalApi";
import { store } from "../../store";


export const getPosts = (postRequest: PostRequest) => {
    return async (dispatch: Dispatch) => {
        dispatch(setPostsLoading(true));
        dispatch(setPostError(""));
        const resp: AxiosResponse<GetPostsResponse> = await getPostsRequest(postRequest);
        if (resp?.status !== 200) {
            console.error(resp?.data || resp)
            const errorMsg = String(resp?.data) || "error obteniendo las publicaciones" as any
            dispatch(setPostError(errorMsg));
            return;
        }
        dispatch(setPostsResponse({postType: postRequest.postType, response: resp.data.message}));
        dispatch(setPostsLoading(false));
    }

}

export const getUnApprovedPosts = (postRequest: PostRequest) => {
    return async (dispatch: Dispatch) => {
        dispatch(setPostsLoading(true));
        dispatch(setPostError(""));
        const resp: AxiosResponse<GetPostsResponse> = await getUnApprovedPostsRequest(postRequest);
        if (resp?.status !== 200) {
            console.error(resp?.data || resp)
            const errorMsg = String(resp?.data) || "error obteniendo las publicaciones" as any
            dispatch(setPostError(errorMsg));
            return;
        }
        dispatch(setPostsResponse({postType: postRequest.postType, response: resp.data.message}));
        dispatch(setPostsLoading(false));
    }

}

export const getYearBirthdays = (year: number) => {
	const {birthdaysYearsRequested} = store.getState().posts;
    return async (dispatch: Dispatch) => {
        if (birthdaysYearsRequested.includes(year)) {
            return;
        }
        console.log("***getting birthdays")
        dispatch(setBirthdaysYearRequested(year));
        for (let i =1; i <= 12; i++) {
            getEmployeesBithdays(i)
        }
    }

}


